import {GroupUserEdit} from "./group_user_edit";
require("./group_role_select");
require("admin/teams/teams_select");
import {confirmPlus} from "admin/common/custom_confirm";

class GroupUsers extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.is_admin = (this.dataset.is_admin == 'true');
    this.innerHTML = 
      `<style>
        .dt-center {
          text-align: center;
        }

        .group-user-email {
          width: 20%;
        }

        .group-user-name, .group-user-action {
          width: 10%;
        }

        .group-user-remove {
          color: red;
        }

        .group-user-edit, .group-user-remove, .resend-invitation, .group-user-login {
          cursor: pointer;
        }

        group-users .dataTables_length, group-users .dataTables_filter {
          display: none;
        }
        
        group-users .has-search {
          position: relative;
          margin: auto 20px;
        }
        
        group-users .has-search .form-control {
          padding-left: 2.375rem;
        }
        
        group-users .has-search .form-control-feedback {
            position: absolute;
            left: 2px;
            top: 2px;
            font-size: 20px;
            z-index: 2;
            display: block;
            width: 2.375rem;
            height: 2.375rem;
            line-height: 2.375rem;
            text-align: center;
            pointer-events: none;
            color: #aaa;
        }

        .invite_user_row, #rep_code_container, #rep_code_wrapper {
          display: flex;
          align-items: center;
        }

        #rep_code_wrapper {
          background-color: rgba(70, 160, 255, 0.1);
          border-radius: 5px;
          padding: 5px 0;
          margin-right: 5px;
        }

        #rep_code_wrapper label {
          margin: 0;
        }

        #rep_code_container {
          width: 240px;
          padding-left: 10px;
        }

        /* Remove arrows from number input */
        /* Chrome, Safari, Edge, Opera */
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        /* Firefox */
        input[type=number] {
          -moz-appearance: textfield;
        }
      </style>
      <h3>Group Users</h3>
      <div class="row">
        <div>
          <p>Invite Users to this Group and/or Messaging Team</p>
        </div>

        <div  id='group_users' class='form-horizontal'>
          <div class='form-group invite_user_row'>
            <div class='col-lg-3 col-md-3'>
              <input type='text' id='invited_email' data-cy='invited_email' autocomplete="nope" placeholder="Enter Email Address" class='form-control'>
            </div>

            <div class="col-lg-2 col-md-2">
              <select is="group-role-select" id="group_role_select" data-cy='group_role_select' class="form-control"></select>
            </div>

            <div class="col-lg-2 col-md-2 hidden" id="group_user_selected_team_wrapper">
              <select is="teams-select" id='user_selected_team' data-cy='user_selected_team' for_groups='true' class='form-control'></select>
            </div>
            <div class="col-lg-6 col-md-6 hidden" id="rep_code_wrapper">
              <div id="rep_code_container">
                <div class="col-sm-4 no-gutters">
                  <label>Rep Code</label>
                </div>
                <div class="col-sm-8">
                  <input type="text" class="form-control" id="rep_code" placeholder="3-6 digits" minlength="3" maxlength="6">
                </div>
              </div>
              <div class="col-sm-8" id="rep_code_name_inputs">
                <div class="col-sm-6">
                  <input type="text" class="form-control" id="rep_code_first_name" placeholder="First Name">
                </div>
                <div class="col-sm-6">
                  <input type="text" class="form-control" id="rep_code_last_name" placeholder="Last Name">
                </div>
              </div>
              <div class="col-sm-7 no-gutters hidden" id="rep_code_name_exists">
                <label>Full Name:</label> <span id="rep_full_name"></span>
              </div>
            </div>

            <a class="btn btn-primary pull-right" id="invite-user-btn" data-cy="invite-user-btn">Send Invite</a>
          </div>
          <div class="users-nav-right col-sm-2 pull-right">
            <div class="form-group has-search">
              <span class="fa fa-search form-control-feedback"></span>
              <input type="text" class="form-control" id="user_table_search" placeholder="Search...">
            </div>
          </div>

        </div>
      </div>
      <table id="group_user_table" class="table vertical-middle" style="width:100%">
        <thead>
            <tr>
              <th>Email</th>
              <th>Username</th>
              <th>Role(s)</th>
              <th>Action</th>
              <th>Status</th>
            </tr>
        </thead>
      </table>`;

    this.init();
  }

  async init() {
    let group_id = document.getElementById('object_id').value;
    let is_admin = this.is_admin;
    this.table = $(this.querySelector('#group_user_table')).DataTable({
      "ajax": `/admin/groups/${group_id}/users`,
      "columns": [
        {
          "data": "email",
          "className" : "group-user-email"
        },
        {
          data: "user_profile",
          "className" : "group-user-name",
          "render" : function ( data, type, row ) {
            return `${data.first_name} ${data.last_name}`
          }
        },
        {
          "render": function ( data, type, row ) {
            let matching_users = row.auto_group_roles.filter(group => group.auto_group_id == group_id);
            let teams = row.teams.length > 0 ? row.teams.filter(team => team.group_id == group_id) : null;
                                                    // Display roles other than messaging agent
            let roles = matching_users.map(role => role.group_role_name != "messaging_agent" || role.group_role_name != "message_agent_with_outbound" ? `<div class="badge badge-pill badge-info">${role.group_role_display_name}</div>` :
                                                    // Display just 'Messaging Agent' if not assigned to a team
                                                    (!teams ? `<div class="badge badge-pill badge-info">${role.group_role_display_name}</div>` :
                                                    // Display 'Messaging Agent' with team name if assigned to a team
                                                    teams.map(team => `<div class="badge badge-pill badge-info">${role.group_role_display_name} - ${team.name}</div>`).join(' '))).join(' ')
            return roles
          },
        },
        {
          "render": function ( data, type, row ) {
            return `<a class="group-user-edit">Edit</a> |${is_admin ? ' <a class="group-user-login">Login As |</a>' : ''} <a class="group-user-remove">Remove</a>`
          },
          "className" : "dt-center group-user-action"
        },
        {
          "render": function( data, type, row ) {
            let total_logins = row.sign_in_count;
            let last_login = moment(row.last_sign_in_at).format("MMM DD, YYYY H:mm A");
            return `<span>${total_logins} Logins</span> | ${total_logins == 0 ? '<a class="resend-invitation">Resend Invitation</a>' : `<span>Last Login Time: ${last_login}</span>`}`
          }
        }
      ],
      order: [[ 0, "asc" ]]
    });

    // Open Edit User page
    $('#group_user_table tbody').on('click', 'tr td a.group-user-edit', function (e) {
      let tr  = $(this).closest('tr')
      let row_data = $('#group_user_table').DataTable().row(tr).data();
      document.querySelector('group-users').classList.add('hidden');
      let editPage = new GroupUserEdit(row_data, group_id, is_admin);
      document.querySelector('#users_tab').appendChild(editPage)
    });

    // Remove user (all roles) from group
    $('#group_user_table tbody').on('click', 'tr td a.group-user-remove', function (e) {
      let tr = $(e.target).closest('tr')
      let row_data = $('#group_user_table').DataTable().row(tr).data();
      this.removeUser(row_data);
    }.bind(this));

    // Login as linked user
    $('#group_user_table tbody').on('click', 'tr td a.group-user-login', async function (e) {
      let tr = $(e.target).closest('tr')
      let row_data = $('#group_user_table').DataTable().row(tr).data();
      window.location = `/admin/users/${row_data.id}/login_as`;
    }.bind(this));

    // Resend invitation
    $('#group_user_table tbody').on('click', 'tr td a.resend-invitation', function (e) {
      let tr = $(e.target).closest('tr')
      let row_data = $('#group_user_table').DataTable().row(tr).data();
      this.resendInvitation(row_data.id);
    }.bind(this));

    // search bar
    let user_table = $('#group_user_table').DataTable();
    $('#user_table_search').keyup(function() {
      user_table.search($(this).val()).draw();
    })

    //Toggle team select visibilty
    this.querySelector('#group_role_select').addEventListener('change', function() {
      if(this.querySelector('#group_role_select').getCurrentName() == "messaging_agent" || this.querySelector('#group_role_select').getCurrentName() == "message_agent_with_outbound") {
        this.querySelector('#group_user_selected_team_wrapper').classList.remove('hidden');
        this.querySelector('#rep_code_wrapper').classList.add('hidden');
      } else if (this.querySelector('#group_role_select').getCurrentName() == "representative") {
        // show rep code component
        this.querySelector('#rep_code_wrapper').classList.remove('hidden');
        this.querySelector('#group_user_selected_team_wrapper').classList.add('hidden');
      } else {
        this.querySelector('#group_user_selected_team_wrapper').classList.add('hidden');
        // hide rep code component
        this.querySelector('#rep_code_wrapper').classList.add('hidden');
      }
    }.bind(this));

    // Handle invite button and errors
    this.querySelector('#invite-user-btn').addEventListener('click', function() {
      if(!this.querySelector('#invited_email').value) {
        Common.notify('Please enter a valid email address.', 'danger')
        return
      }
      if(this.querySelector('#group_role_select').value == "null") {
        Common.notify('Please select a role for the user.', 'danger')
        return
      }
      if((this.querySelector('#group_role_select').getCurrentName() == "messaging_agent" || this.querySelector('#group_role_select').getCurrentName() == "message_agent_with_outbound") 
        && !this.querySelector('#user_selected_team').value) {
        Common.notify('Messaging Agent must be assigned a team.', 'danger')
        return
      }

      // These fields are only required for representative users.
      if(this.querySelector('#group_role_select').getCurrentName() == "representative") {
        if(this.querySelector('#rep_code').value.length < 3 || this.querySelector('#rep_code').value.length > 6) {
          Common.notify('Rep Code must be between 3 and 6 digits.', 'danger')
          return
        }
        if(!parseInt(this.querySelector('#rep_code').value)) {
          Common.notify('Rep Code must be a number.', 'danger')
          return
        }

        // First and last name are only required if user is not already setup.
        if(this.new_user_data.user == null || (!this.new_user_data.user.first_name && !this.new_user_data.user.last_name)) {
          if(!this.querySelector('#rep_code_first_name').value || !this.querySelector('#rep_code_last_name').value) {
            Common.notify('First and last name required.', 'danger')
            return
          }
        }
      }
      this.inviteUser();
      
    }.bind(this));

    this.querySelector('#invited_email').addEventListener("change", async function(e) {
      e.target.value

      let body = {
        email: e.target.value
      };
      let result = await fetch(`/admin/users/find`, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      })
      if(result.ok) {
        let result_body = await result.json();
        this.new_user_data = result_body;
        this.handleUserName(this.new_user_data);
        console.log(result_body);
      }
    }.bind(this));
  }

  reloadTableData() {
    this.table.ajax.reload();
  }

  async inviteUser() {
    let invited_email = this.querySelector('#invited_email').value
    this.querySelector('#invited_email').classList.remove('error');
    if(this.validateEmail(invited_email)) {
      let body = {
        group_id: document.getElementById('object_id').value,
        email: invited_email,
        role_id: this.querySelector('#group_role_select').value,
        team_id: this.querySelector('#user_selected_team').value,
        employee_code: this.querySelector('#rep_code').value,
        first_name: this.querySelector('#rep_code_first_name').value,
        last_name: this.querySelector('#rep_code_last_name').value
      };
      let result = await fetch(`/admin/group/invite`, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      })
      let response = await result.json();
      if(response.success) {
        Common.notify('Invite sent', 'success');
        this.reloadData();
      }
      else {
        Common.notify(response.msg != null ? response.msg : 'Failed to send invite', 'error');
      }
    }
  }

  async removeUser(data) {
    if(await confirmPlus('Are you sure you want to remove this user from the group?')) {
      let group_id = document.getElementById('object_id').value;
      let body = {user_id: data.id, teams: data.teams};
      let result = await fetch(`/admin/groups/${group_id}/remove_user`, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      })
      if(result.ok) {
        Common.notify('User removed from group', 'success');
        this.reloadData();
      }
      else {
        Common.notify('Failed to remove user', 'error');
      }
    }
  }

  async resendInvitation(id) {
    let group_id = document.getElementById('object_id').value;
    let body = {user_id: id, group_id: group_id};
    let result = await fetch('/admin/group/resend_invitation', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })
    if(result.ok) {
      Common.notify("Invitation sent.", 'success');
    }
    else {
      Common.notify(result.msg, 'danger');
    }
  }

  handleUserName(data) {
    this.querySelector('#rep_code_first_name').value = '';
    this.querySelector('#rep_code_last_name').value = '';
    if(data && data.user != null && data.user.first_name && data.user.last_name) {
      this.querySelector('#rep_code_name_inputs').classList.add('hidden');
      this.querySelector('#rep_code_name_exists').classList.remove('hidden');
      this.querySelector('#rep_full_name').innerHTML = `${data.user.first_name ? data.user.first_name : ''} ${data.user.last_name ? data.user.last_name : ''}`;
      this.querySelector('#rep_code_first_name').value = data.user.first_name;
      this.querySelector('#rep_code_last_name').value = data.user.last_name;
      this.querySelector('#rep_code_wrapper').classList.remove('col-lg-6', 'col-md-6');
      this.querySelector('#rep_code_wrapper').classList.add('col-lg-4', 'col-md-4');
      // Set hidden inputs to name? Set condition to ignore on save?
    } else {
      this.querySelector('#rep_code_name_inputs').classList.remove('hidden');
      this.querySelector('#rep_code_name_exists').classList.add('hidden');
      this.querySelector('#rep_code_wrapper').classList.add('col-lg-6', 'col-md-6');
      this.querySelector('#rep_code_wrapper').classList.remove('col-lg-4', 'col-md-4');
    }
  }

  validateEmail(input) {
    let validRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;
    if (input.match(validRegex)) {
      return true;
    } else {
      this.querySelector('#invited_email').classList.add('error');
      Common.notify('Invalid email address', 'danger');
      return false;
    }
  }  

  show() {
    this.classList.remove('hidden');
  }

  reloadData() {
    this.querySelector('#rep_code_first_name').value = '';
    this.querySelector('#rep_code_last_name').value = '';
    this.querySelector('#rep_code').value = '';
    this.querySelector('#group_role_select').value = "null";
    this.querySelector('#user_selected_team').value = "";
    this.querySelector('#invited_email').value = '';
    this.querySelector('#rep_code_wrapper').classList.add('hidden');
    this.querySelector('#group_user_selected_team_wrapper').classList.add('hidden');
    this.handleUserName();
    this.table.ajax.reload();
  }
}

customElements.define('group-users', GroupUsers)